module.exports = __webpack_public_path__ + "img/NVlogo.411ae3f6.svg";